import {I18n} from 'aws-amplify/utils';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {AddRecordButton} from '../buttons/AddRecordButton.tsx';
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import {FilterRecordsButton, AliasFilters} from '../buttons/FilterRecordsButton.tsx';
import {DeleteRecordButton} from '../buttons/DeleteRecordButton.tsx';
import {GenerateAliasButton} from '../../test-data/buttons/GenerateAliasButton.tsx';
import {config} from "../config";
import {AliasStatus} from '../types';
import {rbacActions} from "../../../config/rbac/actions.ts";

interface IndexPageHeaderProps {
    onFilterChange: (filters: AliasFilters) => void;
}

const useTools = (onFilterChange: (filters: AliasFilters) => void) => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [
        <FilterRecordsButton key='filter' onFilterChange={onFilterChange} defaultFilters={{aliasStatus: AliasStatus.ENABLED, aliasType: null}}/>,
        <ReloadRecordsButton key='reload'/>,
        <GenerateAliasButton key='generate'/>
    ];

    if (allowedActions.includes(rbacActions.DeleteAlias)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes(rbacActions.CreateAlias)) {
        tools.push(<AddRecordButton key='add'/>);
    }


    return tools;
};

export const IndexPageHeader = ({onFilterChange}: IndexPageHeaderProps) => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools(onFilterChange)}
        />
    );
};
